import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, inject } from '@angular/core';

import { CrmPromoIdsMap, EventModel, EventOption, EventOptionGroup, OptionGroup2 } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';
import { groupBy, keys } from 'lodash-es';

import { MarketHelpComponent } from './market-help/market-help.component';
import { OptionComponent } from './option.component';

@Component({
    selector: 'ms-head-to-head-option-group',
    templateUrl: './head-to-head-option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MarketHelpComponent, NgTemplateOutlet, OptionComponent],
})
export class HeadToHeadOptionGroupComponent implements OnChanges {
    sitecore = inject(Sitecore);

    @Input() event: EventModel;
    @Input() tracking: string;
    @Input() optionGroup: EventOptionGroup;
    @Input() showMarketHelp: boolean;
    @Input() crmPromoIdsMap: CrmPromoIdsMap;
    @Input() eventHelpText?: string;
    @Input() sourceOfPick = SourceOfPick.Other;
    @Input() betDetails = '';

    optionGroups: OptionGroup2[];
    players: string[] = [];

    ngOnChanges(): void {
        this.players = this.getPlayerNames(this.optionGroup.options);
        const groups = this.groupOptions();

        this.optionGroups = keys(groups).map((key) => ({
            attribute: key,
            options: this.getOptions(groups[key], this.players),
        }));
    }

    groupOptions(): Record<string, [...EventOption[]]> {
        return groupBy(this.optionGroup.options, (option) => option.marketAttribute);
    }

    trackOption(index: number, option: EventOption): number {
        return option.id;
    }

    trackPlayer(index: number, player: string) {
        return player;
    }

    trackGroup(index: number, group: OptionGroup2): string {
        return group.attribute || '';
    }

    isMarketPromoted(optionGroupId: number, templateId: number): boolean {
        return !!this.crmPromoIdsMap.markets[optionGroupId] || (templateId != null && !!this.crmPromoIdsMap.templateIds[templateId]);
    }

    private getPlayerNames(optionGroup: EventOption[]): string[] {
        const groups = groupBy(optionGroup, (option) => option.name);

        return keys(groups);
    }

    private getOptions(optionGroup: EventOption[], players: (string | undefined)[]): (EventOption | undefined)[] {
        const options: (EventOption | undefined)[] = [];
        for (const player of players) {
            const groups = optionGroup.filter((o) => o.name === player);
            if (!groups || groups.length === 0) {
                options.push(undefined);
            } else {
                options.push(groups[0]);
            }
        }

        return options;
    }
}
